import React,{useEffect,useRef,useState} from 'react';
import {Box} from '@mui/material';
import {Image as ImageIcon} from '@mui/icons-material';
import {fileService} from '../../services/fileService';

/** Only visible images request small, authorized server derivatives. Never fetch originals for grid icons. */
export default function AuthorizedThumbnail({id,name}:{id:string;name:string}){
 const host=useRef<HTMLDivElement>(null),[url,setUrl]=useState<string>(),[failed,setFailed]=useState(false);
 useEffect(()=>{
  let alive=true,started=false;setUrl(undefined);setFailed(false);
  const load=()=>{if(started)return;started=true;void fileService.buildPreviewUrl(id,undefined,{mode:'thumbnail',width:160,height:120,quality:65,optimize:true}).then(value=>{if(alive)setUrl(value);}).catch(()=>{if(alive)setFailed(true);});};
  const observer=new IntersectionObserver(entries=>{if(entries.some(row=>row.isIntersecting)){observer.disconnect();load();}},{rootMargin:'100px'});
  if(host.current)observer.observe(host.current);
  return()=>{alive=false;observer.disconnect();};
 },[id]);
 return <Box ref={host} sx={{width:'100%',height:100,display:'flex',alignItems:'center',justifyContent:'center'}}>
  {url&&!failed?<Box component="img" loading="lazy" src={url} alt={name} onError={()=>setFailed(true)} sx={{maxWidth:'100%',maxHeight:100,objectFit:'contain'}}/>:<ImageIcon aria-label="Image preview unavailable" sx={{fontSize:40}}/>}
 </Box>;
}
